import React, { useEffect, useState } from "react";
import MaxDetailModal from "../components/MaxDetailModal";
import $ from "jquery";
import "jstree";
import "jstree/dist/themes/default/style.css";
import axios from "axios";
import { useNavigate, useOutletContext } from "react-router-dom";


export default function Gamelimit() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const { setIsLoggedIn } = useOutletContext();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [VendorLimit, setVendorLimit] = useState([]);
  const [VendorList, setVendorList] = useState([]);
  const [editValues, setEditValues] = useState({});
  const [category, setCategory] = useState("default_option");

  const [showMaxModal, setShowMaxModal] = useState(false);
  const [selectedVendorGames, setSelectedVendorGames] = useState([]);
  const [selectedModalVendor, setSelectedModalVendor] = useState(null);
  const [limitList, setLimitList] = useState([]);
  const [batchWinLimit, setBatchWinLimit] = useState("");
  const [batchWinLoading, setBatchWinLoading] = useState(false);
  const [batchWinCats, setBatchWinCats] = useState({
    all: true,
    casino: false,
    slot: false,
  });

  const toggleBatchWinCat = (key) => {
    if (key === "all") {
      setBatchWinCats({ all: true, casino: false, slot: false });
      return;
    }
    setBatchWinCats((prev) => {
      const next = { ...prev, all: false, [key]: !prev[key] };
      if (!next.casino && !next.slot) {
        return { all: true, casino: false, slot: false };
      }
      return next;
    });
  };

  const openDetailModal = (vendor) => {
    // 1️⃣ 해당 벤더의 게임들만 필터링
    const vendorGames = limitList.filter(
      (item) => item.vendor === vendor.v_code,
    );

    // 2️⃣ 모달에 넘길 데이터 가공
    const gameItems = vendorGames.map((g) => ({
      idx: g.idx,
      gameId: g.gameId,
      nameKR: g.game_name_kor ?? g.game_name, // KR/EN 분리 안 돼 있으면 동일 사용
      nameEN: g.game_name,
      maxi: g.maxi,

      // 값 변경
      onChange: (val) => {
        const num = Number(val.replace(/\D/g, ""));
        setLimitList((prev) =>
          prev.map((x) =>
            x.idx === g.idx
              ? { ...x, maxi: num }
              : x,
          ),
        );
      },

      // 업데이트
      onUpdate: async (newMaxi) => {
        const token = localStorage.getItem("token");

        await axios.post(
          `${API_BASE}/api/updateGameLimit`,
          {
            userId: user.user_id,
            vendor: vendor.v_code,
            gameId: g.gameId,
            idx: g.idx,
            maxi: newMaxi,
            bet: 0,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        setLimitList((prev) =>
          prev.map((item) =>
            item.idx === g.idx
              ? { ...item, maxi: Number(newMaxi) }
              : item,
          ),
        );

        alert("게임 한도 수정 완료");
      },

      // 초기화: 이 게임 한 건만
      onReset: async () => {
        const token = localStorage.getItem("token");
        const resetValue = 30000000;

        await axios.post(
          `${API_BASE}/api/updateGameLimit`,
          {
            userId: user.user_id,
            vendor: vendor.v_code,
            gameId: g.gameId,
            idx: g.idx,
            maxi: resetValue,
            bet: 0,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        );

        setLimitList((prev) =>
          prev.map((item) =>
            item.idx === g.idx
              ? { ...item, maxi: resetValue }
              : item,
          ),
        );

        setSelectedVendorGames((prev) =>
          prev.map((item) =>
            item.idx === g.idx ? { ...item, maxi: resetValue } : item,
          ),
        );

        alert("초기화 완료");
        return resetValue;
      },
    }));

    // 3️⃣ 모달에 전달
    setSelectedModalVendor(vendor);
    setSelectedVendorGames(gameItems);

    // 4️⃣ 모달 열기
    setShowMaxModal(true);
  };

  const handleModalBatchWinLimit = async (amount, games) => {
    if (!selectedModalVendor) return;
    const token = localStorage.getItem("token");
    const vendorCode = selectedModalVendor.v_code;
    const idxSet = new Set(games.map((g) => g.idx));

    await Promise.all(
      games.map((game) =>
        axios.post(
          `${API_BASE}/api/updateGameLimit`,
          {
            vendor: vendorCode,
            gameId: game.gameId,
            idx: game.idx,
            maxi: amount,
            bet: 0,
          },
          { headers: { Authorization: `Bearer ${token}` } },
        ),
      ),
    );

    setLimitList((prev) =>
      prev.map((item) =>
        item.vendor === vendorCode && idxSet.has(item.idx)
          ? { ...item, maxi: Number(amount) }
          : item,
      ),
    );
    setSelectedVendorGames((prev) =>
      prev.map((item) =>
        idxSet.has(item.idx)
          ? { ...item, maxi: Number(amount) }
          : item,
      ),
    );
  };

  const filteredVendorList = (Array.isArray(VendorList) ? VendorList : []).filter(
    (v) => {
      if (category === "default_option") return true;
      return v.v_type === category;
    },
  );

  const handleBatchWinLimitApply = async () => {
    const maxi = String(batchWinLimit).replace(/[^0-9]/g, "");
    if (!maxi) {
      alert("일괄 적용할 당첨제한 금액을 입력해주세요");
      return;
    }

    const targetVendors = (Array.isArray(VendorList) ? VendorList : []).filter(
      (v) => {
        if (batchWinCats.all) return true;
        if (batchWinCats.casino && v.v_type === "casino") return true;
        if (batchWinCats.slot && v.v_type === "slot") return true;
        return false;
      },
    );

    const targets = targetVendors.filter((vendor) =>
      VendorLimit.some((limit) => limit.a_thirdparty === vendor.v_code),
    );

    if (targets.length === 0) {
      alert("적용할 벤더가 없습니다. 카테고리를 선택해주세요");
      return;
    }

    const catLabel = batchWinCats.all
      ? "전체"
      : [
          batchWinCats.casino ? "카지노" : null,
          batchWinCats.slot ? "슬롯" : null,
        ]
          .filter(Boolean)
          .join(", ");

    if (
      !window.confirm(
        `${catLabel} 벤더 ${targets.length}개에 당첨제한 ${Number(
          maxi,
        ).toLocaleString()} 원을 일괄 적용할까요?\n(세부 게임 당첨제한도 동일 금액으로 변경됩니다)`,
      )
    ) {
      return;
    }

    setBatchWinLoading(true);
    const token = localStorage.getItem("token");
    const nextMaxi = Number(maxi);

    try {
      await Promise.all(
        targets.map((vendor) =>
          axios.post(
            `${API_BASE}/api/updateVendorLimit`,
            { vendorCode: vendor.v_code, maxi: nextMaxi },
            { headers: { Authorization: `Bearer ${token}` } },
          ),
        ),
      );

      const targetCodes = new Set(targets.map((v) => v.v_code));
      setVendorLimit((prev) =>
        prev.map((item) =>
          targetCodes.has(item.a_thirdparty)
            ? { ...item, maxi: nextMaxi }
            : item,
        ),
      );
      setLimitList((prev) =>
        prev.map((item) =>
          targetCodes.has(item.vendor) ? { ...item, maxi: nextMaxi } : item,
        ),
      );
      setEditValues({});
      alert(`당첨제한 일괄변경 완료 (${targets.length}개)`);
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "당첨제한 일괄변경 실패");
    } finally {
      setBatchWinLoading(false);
    }
  };

  const updateLimit = async (vendorCode) => {
    try {
      const token = localStorage.getItem("token");
      const matchedLimit = VendorLimit.find(
        (limit) => limit.a_thirdparty === vendorCode,
      );
      const maxi =
        editValues[vendorCode] !== undefined
          ? editValues[vendorCode]
          : matchedLimit?.maxi;

      if (maxi === undefined || maxi === null || maxi === "") {
        alert("당첨제한 금액을 입력해주세요");
        return;
      }

      const nextMaxi = Number(String(maxi).replace(/,/g, ""));

      await axios.post(
        `${API_BASE}/api/updateVendorLimit`,
        {
          vendorCode,
          maxi: nextMaxi,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      alert("업데이트 완료 (세부 게임 당첨제한도 동일 금액으로 변경됨)");
      setVendorLimit((prev) =>
        prev.map((item) =>
          item.a_thirdparty === vendorCode
            ? { ...item, maxi: nextMaxi }
            : item,
        ),
      );
      setLimitList((prev) =>
        prev.map((item) =>
          item.vendor === vendorCode ? { ...item, maxi: nextMaxi } : item,
        ),
      );
      setEditValues((prev) => {
        const next = { ...prev };
        delete next[vendorCode];
        return next;
      });
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "업데이트 실패");
    }
  };

  const resetLimit = async (vendorCode) => {
    try {
      const token = localStorage.getItem("token");

      await axios.post(
        `${API_BASE}/api/updateVendorLimit`,
        {
          vendorCode,
          maxi: 30000000,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      alert("초기화 완료 (세부 게임 당첨제한도 동일 금액으로 변경됨)");
      setVendorLimit((prev) =>
        prev.map((item) =>
          item.a_thirdparty === vendorCode
            ? { ...item, maxi: 30000000 }
            : item,
        ),
      );
      setLimitList((prev) =>
        prev.map((item) =>
          item.vendor === vendorCode ? { ...item, maxi: 30000000 } : item,
        ),
      );
      setEditValues((prev) => {
        const next = { ...prev };
        delete next[vendorCode];
        return next;
      });
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.error || "초기화 실패");
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("first");

    if (storedUser) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (e) {
        console.error("유저 정보 파싱 오류:", e);
      }
    }
  }, []);

  useEffect(() => {
    if (!user || !user.user_id) return;
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_BASE}/api/MyVendorLimit`, {
          params: {
            userId: user.user_id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setVendorLimit(res.data.limitList);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false); // 로그인 상태 false 처리
            navigate("/login"); // 로그인 화면으로 리다이렉트
            return;
          }
        }
        console.error("유저 정보 불러오기 실패:", err);
      }
    };

    fetchUserInfo();
  }, [user]);

  useEffect(() => {
    if (!user || !user.user_id) return;

    const fetchLimitData = async () => {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get(`${API_BASE}/api/UserGameLimit`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setLimitList(res.data.list); // ⭐ 핵심 부분
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false);
            navigate("/login");
            return;
          }
        }
        console.error("유저 게임 제한정보 불러오기 실패:", err);
      }
    };

    fetchLimitData();
  }, [user]);

  useEffect(() => {
    if (!user || !user.user_id) return;
    const fetchUserInfo = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_BASE}/api/MyVendorList`, {
          params: {
            userId: user.user_id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setVendorList(res.data.List);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          if (
            err.response.status === 401 ||
            err.response.status === 403 ||
            err.response.status === 500
          ) {
            localStorage.removeItem("token");
            setIsLoggedIn(false); // 로그인 상태 false 처리
            navigate("/login"); // 로그인 화면으로 리다이렉트
            return;
          }
        }
        console.error("유저 정보 불러오기 실패:", err);
      }
    };
    fetchUserInfo();
  }, [user]);
  if (!VendorList || !VendorLimit) {
    return <div>로딩 중...</div>;
  }
  return (
    <div className="nk-content">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block vVenderLists" id="opt-x">
              <div className="card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner p-3">
                    <div className="nk-block nk-block-lg">
                      <div className="mb-0">
                        <div className="row tbSearch g-2 align-items-center">
                          <div className="col-auto">
                            <select
                              className="form-select"
                              id="selectCategory"
                              value={category}
                              onChange={(e) => setCategory(e.target.value)}
                              style={{ minWidth: 140 }}
                            >
                              <option value="default_option">전체</option>
                              <option value="casino">카지노</option>
                              <option value="slot">슬롯</option>
                            </select>
                          </div>
                          <div className="col">
                            <div className="d-flex flex-wrap align-items-center gap-3 mb-2">
                              <div className="form-check mb-0">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="winCatAll"
                                  checked={batchWinCats.all}
                                  onChange={() => toggleBatchWinCat("all")}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="winCatAll"
                                >
                                  전체
                                </label>
                              </div>
                              <div className="form-check mb-0">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="winCatCasino"
                                  checked={batchWinCats.casino}
                                  onChange={() => toggleBatchWinCat("casino")}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="winCatCasino"
                                >
                                  카지노
                                </label>
                              </div>
                              <div className="form-check mb-0">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="winCatSlot"
                                  checked={batchWinCats.slot}
                                  onChange={() => toggleBatchWinCat("slot")}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor="winCatSlot"
                                >
                                  슬롯
                                </label>
                              </div>
                            </div>
                            <div
                              className="input-group"
                              style={{ maxWidth: 560 }}
                            >
                              <span className="input-group-text">
                                당첨제한 일괄변경
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                inputMode="numeric"
                                style={{ textAlign: "right" }}
                                placeholder="금액 입력"
                                value={batchWinLimit}
                                disabled={batchWinLoading}
                                onChange={(e) =>
                                  setBatchWinLimit(
                                    e.target.value.replace(/[^0-9]/g, ""),
                                  )
                                }
                              />
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleBatchWinLimitApply}
                                disabled={batchWinLoading}
                              >
                                <i className="fas fa-bolt" />{" "}
                                {batchWinLoading
                                  ? "적용 중..."
                                  : "당첨제한 일괄적용"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-inner tableBox p-0">
                    <div
                      className="table-wrapper"
                      style={{
                        borderTop: "1px dotted rgb(187, 187, 187)",
                      }}
                    >
                      <div
                        className="table-responsive"
                        data-pattern="priority-columns"
                      >
                        <div data-pattern="priority-columns">
                          <table
                            cellSpacing="0"
                            className="table table-small-font table-bordered table-striped vam"
                            id="batlist"
                          >
                            <thead>
                              <tr data-pos-y="0">
                                <th
                                  className="text-center"
                                  data-pos-x="0"
                                  data-priority="1"
                                  id="batlist-col-0"
                                >
                                  벤더사명(KR)
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="1"
                                  data-priority="1"
                                  id="batlist-col-1"
                                >
                                  벤더사명(EN)
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="2"
                                  data-priority="1"
                                  id="batlist-col-2"
                                >
                                  게임 개별 설정
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="3"
                                  data-priority="1"
                                  id="batlist-col-3"
                                >
                                  당첨제한 금액
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="4"
                                  data-priority="1"
                                  id="batlist-col-4"
                                >
                                  -
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredVendorList.map((vendor, idx) => {
                                  const matchedLimit = VendorLimit.find(
                                    (limit) =>
                                      limit.a_thirdparty === vendor.v_code,
                                  );
                                  const hasDetailGames = limitList.some(
                                    (item) => item.vendor === vendor.v_code,
                                  );

                                  const maxiValue = matchedLimit
                                    ? Number(matchedLimit.maxi) || 0
                                    : 0;

                                  return (
                                    <tr key={vendor.v_code || idx}>
                                      <td className="text-center">
                                        {vendor.v_name_kor}
                                      </td>
                                      <td className="text-center">
                                        {vendor.v_name}
                                      </td>

                                      <td className="text-center">
                                        <button
                                          className="btn btn-sm btn-primary"
                                          disabled={!hasDetailGames}
                                          onClick={() =>
                                            openDetailModal(vendor)
                                          }
                                          style={{
                                            opacity: hasDetailGames ? 1 : 0.5,
                                            cursor: hasDetailGames
                                              ? "pointer"
                                              : "not-allowed",
                                          }}
                                          title={
                                            hasDetailGames
                                              ? "세부 게임별 설정"
                                              : "설정 가능한 게임이 없습니다"
                                          }
                                        >
                                          <i className="fas fa-edit" /> 세부
                                          게임별 설정
                                        </button>
                                      </td>

                                      <td className="text-center">
                                        <input
                                          className="form-control"
                                          value={
                                            editValues[vendor.v_code] !==
                                            undefined
                                              ? editValues[vendor.v_code]
                                              : maxiValue.toLocaleString()
                                          }
                                          onChange={(e) => {
                                            const num = e.target.value.replace(
                                              /[^0-9]/g,
                                              "",
                                            );
                                            setEditValues({
                                              ...editValues,
                                              [vendor.v_code]: num,
                                            });
                                          }}
                                          inputMode="numeric"
                                          style={{ textAlign: "right" }}
                                          type="text"
                                        />
                                      </td>

                                      <td className="text-center">
                                        <div className="input-group btn-block">
                                          <button
                                            className="btn btn-sm btn-primary2"
                                            onClick={() =>
                                              updateLimit(vendor.v_code)
                                            }
                                          >
                                            <i className="fas fa-edit" />
                                            <font>수정</font>
                                          </button>

                                          <button
                                            className="btn btn-sm btn-outline-danger"
                                            onClick={() =>
                                              resetLimit(vendor.v_code)
                                            }
                                          >
                                            <i className="fas fa-redo-alt" />
                                            <font>초기화</font>
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <MaxDetailModal
        show={showMaxModal}
        onClose={() => {
          setShowMaxModal(false);
          setSelectedModalVendor(null);
        }}
        gameList={selectedVendorGames}
        bet={0}
        onBatchUpdate={handleModalBatchWinLimit}
      />
    </div>
  );
}
